import TimeSelectorController from './timeselector.controller';

angular
	.module('app.timeselector', [])
	.component('timeselector', {
		templateUrl: 'components/timeselector/timeselector.html',
		controller: TimeSelectorController,
		bindings: {
			time: '=',
			required: '=',
			inputname: '='
		}
	});
